module.exports = __webpack_public_path__ + "static/media/account-cover.53676fa6.png";